import React from "react";
import Navbar from "../../../Navbar/Navbar";
import ScrollTable from "./ScrollTable";
import FooterOfRent from "./FooterOfRent";
import FillDetailRent from "./FillDetailRent";
import swal from "sweetalert";
import errorAduio from "./../../../img/error.mp4";

class TableRent extends React.Component {
  constructor() {
    super();
    this.state = {
      savekrdn: false,
      newpage: true
    };
  }

  onSaveChange = (
    R_frosth,
    R_dataTable,
    R_nawe_barez,
    R_wargr,
    R_zh_barez,
    callback,
    cash,
    FIB,
    owe,
    e
  ) => {
    if (!window.navigator.onLine) {
      swal({
        title: "ببورە",
        text: "هێڵی ئنتەرنێتەکەت کێشەی هەیە",
        icon: "error"
      });
    } else if (R_dataTable.length == 0) {
      const sawtError = new Audio(errorAduio);
      sawtError.play().catch(() => { });
      swal({
        title: "ببورە",
        text: "هەڵە هەیە لە خانەکان",
        icon: "error"
      });
    } else if (
      R_nawe_barez == "" ||
      R_nawe_barez == undefined ||
      R_nawe_barez == null
    ) {
      const sawtError = new Audio(errorAduio);
      sawtError.play().catch(() => { });
      swal({
        title: "ببورە",
        text: "هەڵە هەیە لە خانەکان",
        icon: "error"
      });
    } else if (!window.navigator.onLine) {
      swal({
        title: "ببورە",
        text: "هێڵی ئنتەرنێتەکەت کێشەی هەیە",
        icon: "error"
      });
    } else if (
      R_frosth == "" ||
      R_frosth == "جۆری فرۆشتن" ||
      R_wargr == "" ||
      R_wargr == "ناوی وەرگر"
    ) {
      const sawtError = new Audio(errorAduio);
      sawtError.play().catch(() => { });
      swal({
        title: "ببورە",
        text: "هەڵە هەیە لە خانەکان",
        icon: "error"
      });
    } else if (
      R_frosth == "فرۆشتنی وەکیل" &&
      (R_zh_barez == "" || R_zh_barez == 0 || R_zh_barez == null)
    ) {
      const sawtError = new Audio(errorAduio);
      sawtError.play().catch(() => { });
      swal({
        title: "ببورە",
        text: "هەڵە هەیە لە خانەکان",
        icon: "error"
      });
    } else if (
      !cash && !FIB && !owe
    ) {
      swal({
        title: "ببورە",
        text: "جۆری پارەدان دیاری بکە",
        icon: "error"
      });
    } else {
      callback(e);
      this.setState({
        savekrdn: true,
        newpage: false
      });
      localStorage.removeItem("item");
    }
  };

  onNewPage = () => {
    this.setState({
      savekrdn: false
    });
  };
  render() {
    return (
      <>
        <Navbar />
        <div style={{ backgroundColor: "#2C3539" }}>
          <FillDetailRent
            savekrdn={this.state.savekrdn}
            onNewPage={this.onNewPage}
          />
          <div className="bg-white mt1 mb2">
            <ScrollTable savekrdn={this.state.savekrdn} />
          </div>
          <FooterOfRent
            savekrdn={this.state.savekrdn}
            onSaveChange={this.onSaveChange}
            onNewPage={this.onNewPage}
          />
        </div>
        {/* end wasl u para */}
      </>
    );
  }
}

export default TableRent;
